/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { unit_base_full } from './unit_base_full';
import type { unit_height_full } from './unit_height_full';
import type { unit_type_full } from './unit_type_full';
export type unit_carac_full = {
  adv: string | null;
  aeg: string | null;
  arm: string | null;
  def: string | null;
  dis: string | null;
  evoked: string | null;
  hp: string | null;
  mar: string | null;
  res: string | null;
  fly_adv: string | null;
  fly_mar: string | null;
  version: unit_carac_full.version;
  type: unit_type_full | null;
  height: unit_height_full;
  base: unit_base_full;
};
export namespace unit_carac_full {
  export enum version {
    V1 = 'V1',
    V2 = 'V2',
    V3 = 'V3',
  }
}
